import { createSlice } from "@reduxjs/toolkit";
import { getEssMssFields, updateEssMss } from "./thunk";

const initialState = {
    essMssFields: null,
    essMssFieldsStatus: null,

    updateEssMssFields: null,
    updateEssMssFieldsStatus: null

}

const managerSlice = createSlice({
    name: "manager",
    initialState: initialState,
    reducers: {

        setInitialState: (state) => {
            return initialState
        }

    },
    extraReducers: (builder) => {
        builder.addCase(getEssMssFields.pending, (state, action) => {
            state.essMssFields = null;
            state.essMssFieldsStatus = "PENDING"
        });
        builder.addCase(getEssMssFields.rejected, (state, action) => {
            state.essMssFields = action.payload;
            state.essMssFieldsStatus = "ERROR";
        });
        builder.addCase(getEssMssFields.fulfilled, (state, action) => {
            state.essMssFields = action.payload.fields;
            state.essMssFieldsStatus = "SUCCESS"
        });

        builder.addCase(updateEssMss.pending, (state, action) => {
            state.updateEssMssFields = null;
            state.updateEssMssFieldsStatus = "PENDING"
        });
        builder.addCase(updateEssMss.rejected, (state, action) => {
            state.updateEssMssFields = action.payload;
            state.updateEssMssFieldsStatus = "ERROR";
        });
        builder.addCase(updateEssMss.fulfilled, (state, action) => {
            state.updateEssMssFields = action.payload;
            state.updateEssMssFieldsStatus = "SUCCESS"
        });
    }
})

export const managerActions = managerSlice.actions;

export default managerSlice.reducer;